var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Utils
import { getPropertyAtPath } from './getPropertyAtPath';
/**
 * @description Creates an object composed of the picked object properties.
 *
 * @template T
 * @param {T} obj The object to pick data from
 * @param {(keyof T)[]} paths An array of paths to pick off `obj`
 * @returns {Partial<T>} Key value pairs found in `obj` from `paths`
 *
 * @example
 * pick({ 'a': 1, 'b': '2', 'c': 3 }, ['a'. 'c'])
 * // returns { 'a': 1, 'c': 3 }
 *
 */
export var pick = function (obj, paths) {
    var newObject = {};
    paths.forEach(function (pathItem) {
        newObject = __assign(__assign({}, newObject), getPropertyAtPath(obj, pathItem));
    });
    return newObject;
};
//# sourceMappingURL=pick.js.map